module.exports = __webpack_public_path__ + "static/classhook-onboarding-flowchart-f7e2dd4fa28b64ccc7959a0aa2f71d6e.jpg";